import type { AssignedFarmsContractStatusFilter } from '@/types/apiModels'

export const CONTRACT_STATUS_LABELS: Record<AssignedFarmsContractStatusFilter, string> = {
  signed: 'Contrato firmado',
  terminating: 'En proceso de baja',
  terminated: 'Cierre perdido',
}
